import Stepper from '@/modules/perseo-billing/components/stepper/stepper.component';

interface StepperProps {
  orientation: 'horizontal' | 'vertical';
}

const PaymentCompleteStepper = ({ orientation }: StepperProps) => {
  return (
    <div className="co-flex co-flex-col lg:co-flex-row">
      <Stepper
        orientation={orientation}
        label={'¡Solicitud recibida!'}
        lines={['empty', 'activeStep', 'selected']}
        className="co-w-full lg:co-w-[150px]"
      />
      <Stepper
        orientation={orientation}
        label={'Compra confirmada'}
        lines={['unselected', 'disabledStep', 'unselected']}
        className="co-w-full lg:co-w-[160px]"
      />
      <Stepper
        orientation={orientation}
        label={'Listo para entrega'}
        lines={['unselected', 'disabledStep', 'unselected']}
        className="co-w-full lg:co-w-[150px]"
      />
      <Stepper
        orientation={orientation}
        label={'¡Entrega exitosa!'}
        lines={['unselected', 'disabledStep', 'empty']}
        className="co-w-full lg:co-w-[140px]"
      />
    </div>
  );
};

export default PaymentCompleteStepper;
